export default __webpack_public_path__ + "static/media/empty_catalogs.bd6cd6aa.png";